/**
 * Frontend-safe zero-copy eligibility definitions. Keep this module free of
 * mirror registry imports so browser consumers never bundle server credentials.
 */
export const ZERO_COPY_ELIGIBLE_SOURCE_TYPES = [
  "snowflake",
  "databricks",
] as const;

export type ZeroCopyEligibleSourceType =
  (typeof ZERO_COPY_ELIGIBLE_SOURCE_TYPES)[number];
